import MapContainer from "@/components/map-container/MapContainer";
import MapButtonContainer from "@/components/map-container/components/map-button-container/MapButtonContainer";
import SliderObservation from "@/components/slider-observation/SliderObservation";

import { WeatherDispatch, WeatherSelect } from "@/store/type";
import { WEATHER_STORE } from "@/store/store";
import { useDispatch, useSelect } from "@wordpress/data";
import { getCurrentDateWithDay } from "@/helpers/format-date";
import { ZoomControl } from "@/components/map-container/components/ZoomControl";
import { useWindowSize } from "@/hooks/use-window-resize";
import { mergeForecastDataWithStation } from "@/helpers/weather-data-station";
import { getCurrentLanguage } from "@/helpers/get-current-langage";
import { useState } from "@wordpress/element";

import "./style.scss";

export const App = () => {
	const width = useWindowSize();
	const { setPrevisionDateCard } = useDispatch(
		WEATHER_STORE,
	) as WeatherDispatch;

	const [currentIndex, setCurrentIndex] = useState<number>(0);

	const lang = getCurrentLanguage();

	const { selectedDate, dayliesData, isLoading, stations } = useSelect(
		(select: (store: typeof WEATHER_STORE) => WeatherSelect) => {
			const store = select(WEATHER_STORE);

			return {
				stations: store.getCityState(),
				selectedDate: store.getDateSelectedCityState(),
				...store.getDailyForecast(),
			};
		},
	);

	const mergedForecastDataWithStation = mergeForecastDataWithStation(
		stations.cityData,
		dayliesData,
		lang === "ar",
	);

	const { date, day } = getCurrentDateWithDay(selectedDate);

	if (isLoading) return <div className="weather-map-loading skeleton" />;

	return (
		<div className="weather-map">
			<div className="map-content">
				<MapContainer
					allowInteraction={true}
					showRegionStroke={false}
					zoom={width > 500 ? 8.2 : 7.3}
					position={[47.75, 29.22]}
					filter={"present_weather"}
					forecastDataWithStations={{
						data: mergedForecastDataWithStation,
						show: true,
						selectedDate,
					}}
					controls={[new ZoomControl(false)]}
					showStationLabelAndImage={true}
				/>
			</div>

			<div className="map-footer">
				<MapButtonContainer
					showButtonPause={false}
					prevDisabled={selectedDate.getDate() === new Date().getDate()}
					handleClickPrev={() => {
						setCurrentIndex((prev) => prev - 1);
						setPrevisionDateCard({
							type: "weather",
							date: new Date(selectedDate.setDate(selectedDate.getDate() - 1)),
						});
					}}
					nextDisabled={
						selectedDate.getDate() ===
						new Date(new Date().setDate(new Date().getDate() + 5)).getDate()
					}
					handleClickNext={() => {
						setCurrentIndex((prev) => prev + 1);
						setPrevisionDateCard({
							type: "weather",
							date: new Date(selectedDate.setDate(selectedDate.getDate() + 1)),
						});
					}}
				/>

				<SliderObservation currentValue={currentIndex} maxValue={5} />

				<div className="date-div">
					<p>{day}</p>
					<p>{date}</p>
				</div>
			</div>
		</div>
	);
};

export default App;
